var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from "nuxt-class-component";
import { TsVue } from "~/plugins/TsVue";
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentIndex = 1;
        _this.contents = [
            {
                title: '有能力',
                index: 1,
                icon: '/images/cooperation/qualification/icon_1.png',
                icon_active: '/images/cooperation/qualification/icon_1_active.png',
                text: '具备从业互联网基础应用能力且信誉良好的企业单位（有限公司）'
            },
            {
                title: '有市场',
                index: 2,
                icon: '/images/cooperation/qualification/icon_2.png',
                icon_active: '/images/cooperation/qualification/icon_2_active.png',
                text: '具有客户资源优势和持续拓展市场的能力'
            },
            {
                title: '有前景',
                index: 3,
                icon: '/images/cooperation/qualification/icon_3.png',
                icon_active: '/images/cooperation/qualification/icon_3_active.png',
                text: '认同电商发展趋势及美好前景，认同易安捷对形式的判断'
            }
        ];
        return _this;
    }
    default_1 = __decorate([
        Component
    ], default_1);
    return default_1;
}(TsVue));
export default default_1;



//////////////////
// WEBPACK FOOTER
// /opt/node_modules/ts-loader?{"appendTsSuffixTo":[{}],"transpileOnly":true}!/opt/node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/cooperation/Qualification.vue
// module id = QjeV
// module chunks = 0